import { render, staticRenderFns } from "./DownloadS3Files.vue?vue&type=template&id=3fd2be51&"
import script from "./DownloadS3Files.vue?vue&type=script&lang=js&"
export * from "./DownloadS3Files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports